import { Component, ElementRef, HostListener, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth, Configuration, HttpClientCustom } from '../../shared';
import { SharedData } from '../../shared/sharedData';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';
import { NotificationFilter } from './notificationFilter';
import { Location } from '@angular/common';
import * as _ from 'underscore';

@Component({
    selector: 'NotificationGrid',
    templateUrl: 'notificationGridComponent.html'
})
export class NotificationGridComponent {
    public selectedNotificationTypeItems = [];
    public showSearchFilter: Boolean = false;
    public _baseUrl: string;
    public currentPage: number;
    public notificationChannels = [
        {
            key: 'Email',
            value: 'Email'
        },
        {
            key: 'Stream',
            value: 'Stream'
        }];
    public notificationChannelsFiltered = [
        {
            key: 'Email',
            value: 'Email'
        },
        {
            key: 'Stream',
            value: 'Stream'
        }];
    public selectedNotificationChannels = [
        {
            key: 'Email',
            value: 'Email'
        },
        {
            key: 'Stream',
            value: 'Stream'
        }];
    public notificationFilter: NotificationFilter
        = new NotificationFilter();
    public notifications: any = {
        content: [],
        numberOfElements: 0,
        totalElements: 0
    };
    public notificationTypesTranslate = [];
    public notificationTypes = [];
    public notificationTypesTranslated = [];
    public showLoading: boolean;
    public trackHides: number;
    public notificationTypesList: any = [];
    public selectedNotificationGroup: any = null;
    public allNotificationGroups = [];
    public allNotificationTypes = [];
    public notificationTypesSettings:
        {
            selectAllText: string;
            badgeShowLimit: number;
            classes: string;
            noDataLabel: string;
            searchBy: string[];
            unSelectAllText: string;
            text: string;
            labelKey: string;
            primaryKey: string;
            enableSearchFilter: boolean
        };

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public translate: TranslateService) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.fetchNotifications();
        this.getNotificationTypes();
        this.getNotificationGroups();
        // this.prepareNotificationGroups();
        this.notificationTypesSettings = {
            text: 'Select Notification Types',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: '',
            primaryKey: 'key',
            labelKey: 'value',
            noDataLabel: 'Search  Notification Type',
            enableSearchFilter: true,
            badgeShowLimit: 3,
            searchBy: ['key', 'value']
        };

    }

    public fetchNotifications() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/notification/search';
        self.showLoading = false;
        self.http.post(url, this.notificationFilter).subscribe((result) => {
            self.notifications = result;
            self.showLoading = false;
        }, (error) => {
            this._toaster.showError('Can not load notifications');
            self.showLoading = false;
        });
    }

    public editNotification(notification: any): void {
        this.share.saveData({notificationId: notification.id, eventId: notification.eventId});
        this.router.navigate(['menu/editNotifications']);
    }

    public tableActions(index: number) {
        this.trackHides = index;
    }

    public onPageSizeChanged(): void {
        this.fetchNotifications();
    }

    // Pagination functions
    public onPageChange(): void {
        this.fetchNotifications();
    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }

    public clicked() {
        this.trackHides = null;
        this.showSearchFilter = false;
    }

    public toggleSearch() {
        this.showSearchFilter = this.showSearchFilter ? false : true;
    }

    public getNotificationTypes() {
        let url = this._baseUrl + 'v1/webAdmin/notification/notificationTypes';
        this.http.post(url, {}).subscribe((result) => {
            this.allNotificationTypes = result;
            this.prepareNotificationTypes();
        });
    }

    public getNotificationGroups() {
        let url = this._baseUrl + 'v1/webAdmin/notification/notificationGroups';
        this.http.post(url, {}).subscribe((result) => {
            this.allNotificationGroups = result;
            // this.prepareNotificationGroups();
        });
    }

    // write a function where looks each element in array and tranlate it and push new array
    public prepareNotificationTypes() {
        let self = this;
        _.each(self.allNotificationTypes, function(key) {
            let obj = {};
            self.translate.get(key).subscribe((val) => {
                obj['key'] = key;
                obj['value'] = val;
            });
            self.notificationTypesTranslated.push(obj);
            self.notificationTypesList.push(obj);
        });
    }

    public searchAndFetchNotificationByFilterData() {
        if (this.selectedNotificationGroup) {
            if(this.notificationFilter.notificationGroups.indexOf(this.selectedNotificationGroup) == -1){
                this.notificationFilter.notificationGroups = [];
                this.notificationFilter.notificationGroups.push(this.selectedNotificationGroup);
            }
        }
        this.notificationFilter.notificationTypes
            = this.getKeys(this.selectedNotificationTypeItems);
        this.notificationFilter.notificationChannels
            = this.getKeys(this.selectedNotificationChannels);
        this.fetchNotifications();
    }

    public reset() {
        this.selectedNotificationGroup = null;
        this.selectedNotificationTypeItems = [];
        this.notificationFilter = new NotificationFilter();
        this.fetchNotifications();

    }

    public searchStrategy(searchKey) {
        searchKey = searchKey.toLowerCase();
        const filteredArray = _.filter(this.notificationTypesList, function(key) {
            let name = key.value.toLowerCase();
            if (name.match(searchKey)) {
                return key;
            }
        });
        this.notificationTypesTranslated = filteredArray;
    }

    public searchStrategyChannel(searchKey) {
        searchKey = searchKey.toLowerCase();
        const filteredArray = _.filter(this.notificationChannels, function(key) {
            let name = key.value.toLowerCase();
            if (name.match(searchKey)) {
                return key;
            }
        });
        this.notificationChannelsFiltered = filteredArray;
    }

    public getKeys(data) {
        let keys = [];
        for (let t of data) {
            keys.push(t.key);
        }
        return keys;
    }

    onRefresh(){

    }
}



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/notificationGridComponent.ts